import React from 'react';

import {
  ButtonType,
  ButtonWidget,
  InteractionState,
  TabStyles
} from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ExplorerToolbarTestIds } from './ExplorerToolbar';

const ADVANCED_FILTER_ICON_PATH = imgPath('spaces_filter_filters_not_applied.svg');
const ADVANCED_FILTER_ICON_ACTIVE_PATH = imgPath('spaces_filter_filters_not_applied_active.svg');
const ADVANCED_FILTER_APPLIED_ICON_PATH = imgPath('spaces_filter_filters_applied.svg');
const ADVANCED_FILTER_APPLIED_ACTIVE_ICON_PATH = imgPath('spaces_filter_filters_applied_active.svg');
const ADVANCED_FILTER_ICON_DISABLED_PATH = imgPath('spaces_filter_filters_not_applied_disabled.svg');


export interface AdvancedFilterPanelToggleButtonProps {
  readonly advancedFilterButtonClickHandler: () => void;
  readonly filtersApplied: boolean;
  readonly disabled: boolean;
}

export class AdvancedFilterPanelToggleButton extends React.PureComponent<AdvancedFilterPanelToggleButtonProps> {
  public constructor(props: AdvancedFilterPanelToggleButtonProps) {
    super(props);
  }

  private getButtonTestIdSuffix() {
    return this.props.filtersApplied? '-applied-filters' : '';
  }

  private getActiveIcon = (filtersApplied: boolean): string => {
    return filtersApplied ? ADVANCED_FILTER_APPLIED_ACTIVE_ICON_PATH : ADVANCED_FILTER_ICON_ACTIVE_PATH;
  }

  private getContent = (state: InteractionState): JSX.Element => {
    let src = ADVANCED_FILTER_ICON_PATH;
    if (state.active || state.focus || state.hover) {
      src = this.getActiveIcon(this.props.filtersApplied);

    } else if (state.disabled) {  // filters should never be active if the filter panel is disabled so we only have a disabled icon for filters not applied
      src = ADVANCED_FILTER_ICON_DISABLED_PATH;

    } else if (this.props.filtersApplied) {  // inactive filters-applied
      src = ADVANCED_FILTER_APPLIED_ICON_PATH;
    }

    /* eslint-disable jsx-a11y/alt-text */
    return <img style={{width: '18px', height: '18px', marginTop: 1}} src={src} />;
  }

  public render(): JSX.Element {
    return (
      <ButtonWidget
        disabled={this.props.disabled}
        buttonType={ButtonType.Icon}
        getContent={this.getContent}
        title={Messages.filters()}
        testId={'advanced-filter-panel' + this.getButtonTestIdSuffix()}
        data-tb-test-id={ExplorerToolbarTestIds.FilterPanelButton + this.getButtonTestIdSuffix()}
        handleClick={this.props.advancedFilterButtonClickHandler}
        style={{
          // Don't want the double 6 pixel margin between filter and view mode buttons
          marginLeft: 0,
          paddingRight: TabStyles.Spacing.DefaultSpace,
          paddingLeft: TabStyles.Spacing.DefaultSpace
        }}
      />
    );
  }
}
